/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Titles_Loginhistory1Inputs */

const en_settings_titles_loginhistory1 = /** @type {(inputs: Settings_Titles_Loginhistory1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login History`)
};

/**
* | output |
* | --- |
* | "Login History" |
*
* @param {Settings_Titles_Loginhistory1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_titles_loginhistory1 = /** @type {((inputs?: Settings_Titles_Loginhistory1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Titles_Loginhistory1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_titles_loginhistory1(inputs)
});
export { settings_titles_loginhistory1 as "settings_titles_loginHistory" }